module.exports = __webpack_public_path__ + "media/images/icon__point--text-d926ef3713836f22cb7338546587938e.png";